import { SetStateAction, atom } from 'jotai';
import { z } from 'zod';

import { atomWithLocalStorage } from '../../../utils/browserStorage';

// Breakpoint for mobile vs desktop (px)
export const GLOBAL_NAV_MOBILE_BREAKPOINT = 768;

// Padding for drawer items (theme.spacing units)
export const DRAWER_ITEM_PADDING_LEFT = 2;

// App bar heights
export const appBarHeightMobile = '56px';
export const appBarHeightDesktop = '0px';

// Navigation drawer widths
export const closedNavDrawerWidthMobile = '0px';
export const closedNavDrawerWidthDesktop = '60px';
export const openNavDrawerWidth = '240px';

// Internal localStorage atom - stores the actual persisted value
// Initialize drawer state: open on desktop (>768px), closed on mobile
// Persists across logout since this is a UX preference
const isGlobalDrawerOpenStorageAtom = atomWithLocalStorage(
    'globalNavigationDrawerOpen',
    typeof window !== 'undefined' ? window.innerWidth > GLOBAL_NAV_MOBILE_BREAKPOINT : true,
    z.boolean(),
);

// Public atom that wraps the storage atom and supports functional updates (SetStateAction)
// This allows components to use: setIsDrawerOpen(prev => !prev)
export const isGlobalDrawerOpenAtom = atom(
    (get) => get(isGlobalDrawerOpenStorageAtom),
    (get, set, update: SetStateAction<boolean>) => {
        const nextValue =
            typeof update === 'function' ? update(get(isGlobalDrawerOpenStorageAtom)) : update;
        set(isGlobalDrawerOpenStorageAtom, nextValue);
    },
);
